export const EmbeddedVideo = (p: { link: string; title: string }) => {
  return (
    <>
      <div class="md:h-[400px] md:w-[600px] h-[240px] w-[360px] rounded-md p-4 bg-violet-100 mx-14 my-4 flex flex-col ">
        <h2 class="mb-2 font-bold">{p.title}</h2>
        <iframe
          class="w-full h-full"
          src={p.link}
          title="YouTube video player"
          allow="accelerometer;
           clipboard-write; encrypted-media;
            gyroscope; picture-in-picture; allowfullscreen;
            loop"
        ></iframe>
      </div>
    </>
  );
};

//<div class="flex lg:flex-row flex-col justify-center items-center">
